import { i18n } from '../../lang/i18n';
import UserLoginScreen from "./Login/UserLoginScreen";
import { credentialClear } from "../../store/UserData/UserData";
import { NavLink } from "react-router-dom";
import QRPrint from "../../components/QRComponent/QRPrint"
import Helpers from "../../common/Helpers";
import TokenStore from "../../common/TokenStore";
import { MethodActive } from "../../common/Conf";
import { renderIcon } from "../../common/Medias";
import { useAppDispatch, useAppSelector } from "../../store/hooks";


export default function TabUser()
{
    const dispatch = useAppDispatch()
    const userData = useAppSelector((state) => state.userData)
    function onSessionClose()
    {
        TokenStore.remove()
        credentialClear(dispatch)
    }

    if (!userData.isActive)
        return (<div className="login-box">
            <UserLoginScreen />
        </div>);

    return (
        <div className="users">
            <div className="users-header">
                {renderIcon('header-user')}
            </div>
            <div className="text-center">
                <p>{i18n.TabUser.RegisteredWithEmail}</p>
                <div>{userData.user.email}</div>
                <h5 className="user-code">{userData.user.code}</h5>
            </div>
            <div className="user-qr">
                <QRPrint value={Helpers.UserGenerateQRData(userData)} />
            </div>
            <ul className="list-group">
                {MethodActive('menu_delivery_orders') && <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/deliver_orders" className="link-btn">
                                <div>{renderIcon('menu-orders')}</div>
                                <h5>{i18n.TabUser.MenuDeliveryOrders}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>}
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/loyalty" className="link-btn">
                                <div>{renderIcon('menu-loyalty')}</div>
                                <h5>{i18n.TabUser.MenuLoyaltyProgram}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/invoices" className="link-btn">
                                <div>{renderIcon('menu-invoices')}</div>
                                <h5>{i18n.TabUser.MenuInvoices}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/settings" className="link-btn">
                                <div>{renderIcon('menu-preferences')}</div>
                                <h5>{i18n.TabUser.MenuPreferences}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
                {MethodActive('menu_address') && <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/address" className="link-btn">
                                <div>{renderIcon('menu-address')}</div>
                                <h5>{i18n.TabUser.MenuAddress}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>}
            </ul>
            <div onClick={onSessionClose} className="user-close-session">
                {i18n._BTNs.SignOut} <i className="fas fa-sign-out-alt fa-fw"></i>
            </div>
        </div>
    )
}